import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'store';

export const selectSelectedDevices = (state: RootState) =>
  state.cloverDevice.selectedDevices;

export const selectDeviceForEvent = (eventId: number) =>
  createSelector([selectSelectedDevices], (devices) => devices[eventId]);
